import apiInstance from "./axios";
import { lucky_draw } from "utils/services/api/schemas";

const luckyDrawApi = {
  createLuckyDraw: async (data, isFormData) => {
    const response = await apiInstance.post(lucky_draw, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });

    return response;
  },
  getLuckyDrawById: async (caddyId, id) => {
    const response = await apiInstance.get(`${lucky_draw}/${caddyId}/${id}`);
    return response;
  },
};

export default luckyDrawApi;
